import { sendOTPApi } from 'entities/sendOTP/model';
import { HTTP_METHODS } from 'shared/consts';
import { toast } from 'react-toastify';
import { ErrorMessageDataType } from 'shared/types';

const createUpdateOTPApi = sendOTPApi.injectEndpoints({
  endpoints: (builder) => ({
    createOTP: builder.mutation({
      query: ({ data }) => ({
        url: '/callpassword/admin/methodprioritys/',
        method: HTTP_METHODS.POST,
        body: data,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.data as ErrorMessageDataType;
        if (error) {
          toast.error(error_message.detail, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили способ отправки', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'SendOTP' }];
      },
    }),
    updateOTPById: builder.mutation({
      query: ({ id, data }) => ({
        url: `/callpassword/admin/methodprioritys/${id}`,
        method: HTTP_METHODS.PATCH,
        body: data,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.data as ErrorMessageDataType;
        if (error) {
          toast.error(error_message.detail, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили способ отправки', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'SendOTP' }];
      },
    }),
  }),
});

export const { useCreateOTPMutation, useUpdateOTPByIdMutation } = createUpdateOTPApi;
